(() => {
  if (window.__ihBagSizeInstalled) return;
  window.__ihBagSizeInstalled = true;
  const root = () => window.Shopify?.routes?.root || '/';
  async function request(url, body) {
    const response = await fetch(root() + url, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
    const data = await response.json();
    if(!response.ok) throw new Error(data.description || data.message || 'Cart update failed');
    return data;
  }
  document.addEventListener('change', async event => {
    const el = event.target.closest('[data-ih-size-change]');
    if (!el || el.disabled) return;
    const nextId = Number(el.value);
    const originalId = Number(el.dataset.currentVariant);
    const lineKey = el.dataset.lineKey;
    if (!nextId || !originalId || nextId === originalId || !lineKey) return;
    const oldOption = Array.from(el.options).find(x=>Number(x.value)===originalId);
    el.disabled = true;
    try {
      const cart = await fetch(root()+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
      const current = cart.items.find(x=>x.key===lineKey);
      if (!current) throw new Error('Cart item changed. Refresh and try again.');
      // Add new variant first. Never remove old stock before confirming add succeeded.
      const add = {id: nextId, quantity:current.quantity};
      if (current.properties && Object.keys(current.properties).length) add.properties = current.properties;
      if (current.selling_plan_allocation?.selling_plan?.id) add.selling_plan = current.selling_plan_allocation.selling_plan.id;
      await request('cart/add.js',{items:[add]});
      try {
        await request('cart/change.js',{id:lineKey,quantity:0});
      } catch(error) {
        // Attempt rollback of the newly added quantity; preserve old line item.
        try {
          const after=await fetch(root()+'cart.js').then(r=>r.json());
          const created=after.items.find(x=>x.variant_id===nextId && JSON.stringify(x.properties||{})===JSON.stringify(current.properties||{}));
          if(created) await request('cart/change.js',{id:created.key,quantity:Math.max(0,created.quantity-current.quantity)});
        } catch(_) {}
        throw error;
      }
      location.reload();
    } catch(error) {
      if(oldOption) el.value=oldOption.value;
      el.disabled=false;
      window.alert(error.message || 'Could not change size. Please try again.');
    }
  });
})();
